module.exports = __webpack_public_path__ + "static/media/logo_idram.f7a2f8b9.png";